const NotFoundPage = resolve => require(['../layouts/404.vue'], resolve)

const CommonRouter = {}

CommonRouter.routers = [
  {
    path: '/404',
    component: NotFoundPage,
    hidden: true,
    meta: {
      title: '404',
      auth: false
    }
  },
  {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
  }
]

export default CommonRouter



// WEBPACK FOOTER //
// ./src/router/common.router.js